<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div *ngIf="token">
    <section>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-7">
            <h4 style="float:right;">
              User Transaction History
            </h4>
          </div>

          <div class="col-lg-5">
            <button class="btn btn-primary" (click)="Back()" style="float:right;">Back</button>

          </div>

        </div>
        <hr class="hr-border" />
      </div>
    </section>


    <section>



      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">

            <p *ngIf="total_count===0">
              <strong>Sorry!</strong> No record found!.
            </p>
            <br />
            <div *ngIf="total_count>0">
              <table class="table table-hover text-center  table-bordered table-responsive" border="1">
                <thead class="theme-button text-white">
                  <tr>
                    <th scope="col">Product Name</th>
                    <th scope="col">Invoice No. </th>

                    <th scope="col">Amount</th>
                    <th scope="col">Transaction Status</th>
                    <th scope="col">Transaction Date & Time </th>
                    <th scope="col">UTR No. </th>
                    <th scope="col">Promo Code IsUsed</th>
                    <th scope="col">Promo Code</th>
                    <th scope="col">Promo Code Expiry Date & Time </th>

                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let x of userorderdetailList">

                    <td class="accept">
                      <span> {{x.Products}} </span>
                    </td>

                    <td class="accept">

                      {{x.InvoiceNo }}
                    </td>

                    <td class="accept">
                      <span> {{x.Amount}} INR </span>
                    </td>

                    <td class="accept">
                      <span> {{x.TransactionStatusText}}  </span>
                    </td>

                    <td class="accept">
                      <span>{{x.EntryDate | date :'medium' }}</span>
                    </td>

                    <td class="accept">
                      <span> {{x.UTR}} </span>
                    </td>


                    <td class="accept">
                      <span>{{x.IsUsed}} </span>
                    </td>

                    <td class="accept">
                      <span> {{x.Code}} </span>
                    </td>


                    <td class="accept">
                      <span> {{x.ExpiryDate| date :'medium' }}</span>
                    </td>

                  </tr>

                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
      <div class="pagenation-wrapper" *ngIf="total_count>0">
        <mat-paginator [length]="total_count" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" #paginator
                       (page)="handle($event)">
        </mat-paginator>
      </div>
    </section>
  </div>
</fieldset>
